import { pushEvent } from '../utils/analytics'

export default {
  pushEvent
}
